import * as React from 'react';

interface TruncateWordProps {
  text: string;
  limit: number;
}

export const TruncateWord: React.SFC<TruncateWordProps> = props => {
  return <span>{props.text.length > props.limit ? props.text.substring(0, props.limit) + '...' : props.text}</span>;
};



// WEBPACK FOOTER //
// ./src/common/components/TruncateWord.tsx